import { handleActions, combineActions } from 'redux-actions';
import { LOAD_USER_IS_LOGGEDIN, LOAD_USER_LOGIN_SSO } from '../constants';

const intialState = {
  loading: false,
  model: null,
  error: false,
};

const modifyReducer = handleActions(
  {
    [LOAD_USER_IS_LOGGEDIN.PENDING]: state => ({
      ...state,
      loading: true,
      error: false,
    }),
    [combineActions(
      LOAD_USER_IS_LOGGEDIN.CANCELLED,
      LOAD_USER_IS_LOGGEDIN.SUCCESS,
      LOAD_USER_IS_LOGGEDIN.ERROR,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [LOAD_USER_IS_LOGGEDIN.SUCCESS]: (state, { payload }) => ({
      ...state,
      model: payload || state.model,
      error: false,
    }),
    [LOAD_USER_IS_LOGGEDIN.ERROR]: state => ({
      ...state,
      error: true,
    }),
    [LOAD_USER_LOGIN_SSO.CLEAR]: () => intialState
  },
  intialState,
);

export default modifyReducer;
